import { Injectable } from '@angular/core';
import { MessageService } from './message.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Organization } from '../models/organization';
import { User } from '../models/user';
import { Plan } from '../models/plan';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Paginator } from '../models/paginator';

@Injectable({
  providedIn: 'root'
})
export class PlanService {

  constructor(
    private _message: MessageService,
    private http: HttpClient
  ) {

  }

  createPlan(plan: Plan) {
    return firstValueFrom(this.http
      .post<Plan>(`${environment.backend}/plans`, plan));
  }

  updatePlan(planId: string, plan: Plan) {
    return firstValueFrom(this.http
      .put<Plan>(`${environment.backend}/plans/${planId}`, plan));
  }


  retrievePlans(pageNumber: number, limit: number, offset: number, sort?: string, query?: string): Promise<Paginator<Plan>> {
    let params = new HttpParams()
      .set('page', pageNumber)
      .set('limit', limit)
      .set('offset', offset)

    if (sort) {
      params = params.set('sort', sort);
    }
    if (query) {
      params = params.set('q', query);
    }

    return firstValueFrom(this.http
      .get<Paginator<Plan>>(`${environment.backend}/plans`, { params }));
  }

  retrievePlan(id: string) {
    return firstValueFrom(this.http
      .get<Plan>(`${environment.backend}/plans/${id}`,));
  }
}
